import { CloseCircleIcon } from './CloseCircleIcon';

/**
 * author: Austin Andrews
 * id DC0E1491-A8A0-4563-ACEC-C795D96602A7
 * name close-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-circle.svg
 * tags
 * - Form 
 */
export const ClearCircleIcon = CloseCircleIcon;
export default ClearCircleIcon